"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStringReplace = _interopRequireDefault(require("react-string-replace"));

var _i18n = _interopRequireDefault(require("../../util/i18n.js"));

var _DetailsRow = _interopRequireDefault(require("./DetailsRow"));

require("./DetailsTable.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DetailsTable =
/*#__PURE__*/
function (_Component) {
  _inherits(DetailsTable, _Component);

  function DetailsTable(props) {
    var _this;

    _classCallCheck(this, DetailsTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DetailsTable).call(this, props));
    _this.state = {
      i18n: _this.props.translationDictionary ? _this.props.translationDictionary : _i18n.default
    };
    return _this;
  }

  _createClass(DetailsTable, [{
    key: "renderRows",
    // create the rows
    value: function renderRows() {
      var data = this.props.data; // Filter out Benchmarks and Common Stock, and Crypto

      return data.filter(function (x) {
        return x.type !== 'BMK' && x.type !== 'WTIDX' && x.type !== 'CS' && x.type !== 'CY' && x.ticker !== '$CASH';
      }).map(function (fund, index) {
        return _react.default.createElement(_DetailsRow.default, {
          key: fund.externalID,
          index: index,
          fund: fund
        });
      });
    } // create the header

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var i18n = this.state.i18n;
      var data = this.props.data;
      var stdPerformance = Array.isArray(data[0].stdPerformance) ? data[0].stdPerformance[0] : data[0].stdPerformance;
      var asOfDate = new Date(stdPerformance.asOfDate).toLocaleDateString();
      return _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
        scope: "col",
        className: "textLeft ticker sticky"
      }, i18n.t('Ticker')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter filings"
      }, i18n.t('Website')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter filings"
      }, i18n.t('Filings')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter category"
      }, i18n.t('Inception Date')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter fees"
      }, i18n.t('Gross Expense Ratio')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter fees"
      }, i18n.t('Net Expense Ratio')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter date"
      }, i18n.t('30-Day SEC Yield, Subsidized'), " (", i18n.t('as of'), " ", asOfDate, ")"), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter date"
      }, i18n.t('30-Day SEC Yield, Unsubsidized'), " (", i18n.t('as of'), " ", asOfDate, ")"), _react.default.createElement("th", {
        scope: "col",
        className: 'col-md-3 textCenter date'
      }, i18n.t('Notes'))));
    }
  }, {
    key: "render",
    value: function render() {
      var footnote = this.props.footnote;
      var formattedFootnoteText;

      if (footnote) {
        formattedFootnoteText = (0, _reactStringReplace.default)(footnote, '<br/>', function (match) {
          return _react.default.createElement("br", {
            key: Math.random()
          });
        });
        formattedFootnoteText = (0, _reactStringReplace.default)(formattedFootnoteText, /<strong>(.*)<\/strong>/g, function (match) {
          return _react.default.createElement("strong", {
            key: Math.random()
          }, match);
        });
      }

      return _react.default.createElement("div", {
        className: "details-table-container"
      }, _react.default.createElement("div", {
        className: "table-responsive"
      }, _react.default.createElement("table", {
        className: 'table'
      }, this.renderHeader(), _react.default.createElement("tbody", null, this.renderRows()))), formattedFootnoteText ? _react.default.createElement("div", {
        className: "perf-footnote"
      }, formattedFootnoteText) : _react.default.createElement("div", null, _react.default.createElement("br", null)));
    }
  }]);

  return DetailsTable;
}(_react.Component);

_defineProperty(DetailsTable, "defaultProps", {
  data: null,
  translationDictionary: null,
  showTitle: true
});

DetailsTable.propTypes = {
  /**
   * Fund data to be used for Performance. Should be array of funds
   */
  data: _propTypes.default.array.isRequired,

  /**
   * Translation dictionary (i18) - needed for tables, but can default to included version
   */
  translationDictionary: _propTypes.default.object,

  /**
   * Show the title or not
   */
  showTitle: _propTypes.default.bool,

  /**
   * Footnote text
   */
  footnote: _propTypes.default.string
};
var _default = DetailsTable;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/dist/components/StandardPerformance/DetailsTable.js
// module id = 959
// module chunks = 0